import { createMRTColumnHelper } from "material-react-table";
import CustomTable from "../../components/customTable/CustomTable";
import { Box, Tooltip } from "@mui/material";
import { IconButton } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";

export default function AllTransactionTable({ data }) {
  const sliceResponse = data?.allTransactions;
  // console.log("datakkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk",sliceResponse)
  const sliceResponseData = sliceResponse?.map((item) => ({
    id: item._id || "N/A",
    price: item.Price || "N/A",
    amount: item.amount || "N/A",
    clientId: item.client_id?._id || "N/A",
    clientName: item.client_id?.name || "N/A",
    commission: item.commission || "N/A",
    partner_comm_per: item.partner_comm_per || "N/A",
    createdAt: item.createdAt || "N/A",
    customerRefNo: item.customerRefNo || "N/A",
    flag: item.flag || "N/A",
    gst: item.gst || "N/A",
    invoiceNo: item.invoice_No || "N/A",
    invoiceUrl: item.invoice_url || "N/A",
    merchantTransactionId: item.merchant_transaction_id || "N/A",
    metalType: item.metal_type || "N/A",
    orderId: item.orderID || "N/A",
    partnerId: item.partner_id || "N/A",
    paymentId: item.payment_id || "N/A",
    paymentMethod: item.payment_method || "N/A",
    proposalId: item.proposal_id || "N/A",
    quantity: item.quantity || "N/A",
    status: item.status || "N/A",
    totalAmount: item.total_amount || "N/A",
    transactionId: item.transaction_id || "N/A",
    updatedAt: item.updatedAt || "N/A",
  }));

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("clientId", {
      header: "Client ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.clientId);
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.clientId}>
            <div>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.clientName || "Batuk Customer"}
            </div>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("id", {
      header: "Transaction ID",
      size: 30,
      Cell: (cell) => cell.row.original?.id || "N/A",
    }),

    columnHelper.accessor("invoiceNo", {
      header: "Invoice No",
      size: 30,
      Cell: (cell) => cell.row.original?.invoiceNo || "N/A",
    }),
    columnHelper.accessor("invoiceUrl", {
      header: "Invoice URL",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.invoiceUrl);
          toast.success("URL copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.invoiceUrl}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId,
          );
          toast.success("copied to clipboard!");
        };

        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <div>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </div>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: (cell) => cell.row.original?.customerRefNo || "N/A",
    }),

    columnHelper.accessor("partnerId", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partnerId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.partnerId}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.partnerName}
            </div>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("proposalId", {
      header: "Proposal ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.proposalId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.proposalId}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.proposalId}
            </div>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
      Cell: (cell) => cell.row.original?.metalType || "N/A",
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
      Cell: (cell) => cell.row.original?.quantity || "N/A",
    }),
    columnHelper.accessor("price", {
      header: "Price",
      size: 30,
      Cell: (cell) => cell.row.original?.price || "N/A",
    }),

    // Payment Details
    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
      Cell: (cell) => cell.row.original?.totalAmount || "N/A",
    }),
    columnHelper.accessor("commission", {
      header: "Commission",
      size: 30,
      Cell: (cell) => cell.row.original?.commission || "N/A",
    }),
    columnHelper.accessor("partner_comm_per", {
      header: "Partner Commission",
      size: 30,
      Cell: (cell) => cell.row.original?.partner_comm_per || "N/A",
    }),
    columnHelper.accessor("gst", {
      header: "GST",
      size: 30,
      Cell: (cell) => cell.row.original?.gst || "N/A",
    }),
    columnHelper.accessor("paymentMethod", {
      header: "Payment Method",
      size: 30,
      Cell: (cell) => cell.row.original?.paymentMethod || "N/A",
    }),

    // Status and Metadata
    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: (cell) => cell.row.original?.status || "N/A",
    }),
    columnHelper.accessor("flag", {
      header: "Flag",
      size: 30,
      Cell: (cell) => cell.row.original?.flag || "N/A",
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
  ];

  return (
    <Box sx={{ mt: 3 }}>
      {sliceResponseData && (
        <CustomTable
          columns={columns}
          data={sliceResponseData}
          permissionKey="Transactions"
        />
      )}
    </Box>
  );
}
